import { render, staticRenderFns } from "./CreateStatusModal.vue?vue&type=template&id=87fd64ac"
import script from "./CreateStatusModal.vue?vue&type=script&lang=js"
export * from "./CreateStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports